import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MailCheck, ArrowLeft, Send } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const inputCls =
  "w-full bg-obsidian border border-white/10 focus:border-gold/60 rounded-xl px-4 py-3.5 text-sm text-[#F5F5F0] placeholder:text-zinc-600 outline-none transition-colors duration-200";

export default function Recuperar() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-5 relative overflow-hidden" data-testid="forgot-page">
      <div aria-hidden="true" className="absolute w-[60vw] h-[60vw] max-w-[700px] max-h-[700px] rounded-full opacity-50" style={{ background: "radial-gradient(circle, rgba(220,38,38,0.4) 0%, transparent 70%)" }} />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative w-full max-w-md bg-surface border border-white/10 rounded-2xl p-8 sm:p-10"
      >
        <div className="flex flex-col items-center text-center">
          <img src="/assets/logo.jpeg" alt="Projeto Bonsai BJJ" className="w-20 h-20 rounded-full object-cover ring-2 ring-gold/50 shadow-[0_0_40px_rgba(220,38,38,0.3)]" />
          <h1 className="font-display text-2xl font-bold mt-5" data-testid="forgot-title">Recuperar Senha</h1>
          <p className="text-sm text-zinc-500 mt-1">Enviaremos um link de redefinição para o e-mail cadastrado</p>
        </div>

        {sent ? (
          <div className="mt-8 text-center space-y-3" data-testid="forgot-success">
            <MailCheck size={36} className="mx-auto text-gold" />
            <p className="text-sm text-zinc-300 leading-relaxed">
              Se este e-mail estiver cadastrado, você receberá o link de redefinição em instantes. Verifique também a caixa de spam.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="forgot-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-mail cadastrado"
              className={inputCls}
              data-testid="forgot-email-input"
            />
            {error && <p className="text-sm text-crimson" data-testid="forgot-error-message">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit-button"
              className="w-full inline-flex items-center justify-center gap-3 font-display font-semibold bg-gold text-obsidian px-8 py-3.5 rounded-full hover:bg-gold-amber disabled:opacity-60 transition-all duration-300"
            >
              <Send size={18} /> {loading ? "Enviando..." : "Enviar Link de Redefinição"}
            </button>
          </form>
        )}

        <Link to="/login" data-testid="forgot-back-login" className="mt-6 flex items-center justify-center gap-2 text-xs font-mono tracking-widest text-zinc-500 hover:text-gold transition-colors">
          <ArrowLeft size={14} /> VOLTAR AO LOGIN
        </Link>
      </motion.div>
    </main>
  );
}
